import ChatView from "@/views/search/ChatView";

export default {
    path: "/chat",
    meta: {auth: true},
    component: ChatView
}